export default {
  searchText: '',
  orderName: 'created_at',
  currentPage: 1,
  sortAsc: false
}
